module.exports = __webpack_public_path__ + "img/design.b33d442d.png";